var SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportViewOrderDetailsServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportViewOrderDetailsServiceActionView = (function(superClass) {
  extend(SupportViewOrderDetailsServiceActionView, superClass);

  function SupportViewOrderDetailsServiceActionView() {
    return SupportViewOrderDetailsServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportViewOrderDetailsServiceActionView.prototype.id = 'view_order_details';

  SupportViewOrderDetailsServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportViewOrderDetailsServiceActionView.prototype.render = function() {
    var hash;
    return hash = this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportViewOrderDetailsServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "view_order_details",
      service_action: I18n.t("js.modules.support.view_details")
    };
    return this.extendHash(hash);
  };

  SupportViewOrderDetailsServiceActionView.prototype.actionHandler = function(event) {
    var url;
    url = "/users/" + currentUser.id + "/hotel_reservations/" + this.order.id;
    return window.open(url);
  };

  SupportViewOrderDetailsServiceActionView.prototype.events = {
    "click #view_order_details": "actionHandler"
  };

  return SupportViewOrderDetailsServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportViewOrderDetailsServiceActionView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvdmlld19vcmRlcl9kZXRhaWxzX3NlcnZpY2VfYWN0aW9uLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL29yZGVyX3JlbGF0ZWQvc2VydmljZV9hY3Rpb25zL3ZpZXdfb3JkZXJfZGV0YWlsc19zZXJ2aWNlX2FjdGlvbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSwyR0FBQTtFQUFBOzs7QUFBQSw2QkFBQSxHQUFnQyxPQUFBLENBQVEsdUJBQVI7O0FBQ2hDLGtDQUFBLEdBQXFDLE9BQUEsQ0FBUSxpREFBUjs7QUFFL0I7Ozs7Ozs7cURBQ0osRUFBQSxHQUFJOztxREFFSixVQUFBLEdBQVksU0FBQTtJQUNWLENBQUMsQ0FBQyxPQUFPLENBQUMsS0FBVixDQUFnQixDQUFoQixFQUFtQixDQUFDLElBQUQsQ0FBTSxDQUFDLE1BQVAsQ0FBYyxDQUFDLENBQUMsU0FBRixDQUFZLElBQVosQ0FBZCxDQUFuQjtJQUNBLElBQUMsQ0FBQSxTQUFELEdBQWE7SUFDYixJQUFDLENBQUEsUUFBRCxHQUFZO1dBQ1osSUFBQyxDQUFBLEtBQUQsR0FBUyxPQUFPLENBQUMsT0FBTyxDQUFDO0VBSmY7O3FEQU1aLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtXQUFBLElBQUEsR0FDQSxJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFsQixFQUE2QixJQUFDLENBQUEsU0FBOUIsQ0FBWjtFQUZNOztxREFJUixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFBLEdBQ0U7TUFBQSxpQkFBQSxFQUFtQixvQkFBbkI7TUFDQSxjQUFBLEVBQWdCLElBQUksQ0FBQyxDQUFMLENBQU8saUNBQVAsQ0FEaEI7O1dBRUYsSUFBQyxDQUFBLFVBQUQsQ0FBWSxJQUFaO0VBSk07O3FEQU1SLGFBQUEsR0FBZSxTQUFDLEtBQUQ7QUFDYixRQUFBO0lBQUEsR0FBQSxHQUFNLFNBQUEsR0FBVSxXQUFXLENBQUMsRUFBdEIsR0FBeUIsc0JBQXpCLEdBQStDLElBQUMsQ0FBQSxLQUFLLENBQUM7V0FDNUQsTUFBTSxDQUFDLElBQVAsQ0FBWSxHQUFaO0VBRmE7O3FEQUlmLE1BQUEsR0FDRTtJQUFBLDJCQUFBLEVBQTZCLGVBQTdCOzs7OztHQXhCbUQ7O0FBMEJ2RCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
